export default {
  setFunnels(state, funnels) {
    state.funnels = funnels;
  },
  setFunnel(state, funnel) {
    state.funnel = funnel;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
